import * as model from "@/model/adm/Role";
// import i18n from "i18n";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.Role(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl : process.env.VUE_APP_ADM_API_URL + "adm-service/adm",
        allMenus: [],
        resourcesLabel:[
            {key:'resourceType',label:'lbl.role.resources.resourceType'},
            {key:'functions',label:'功能编号'},
            {key:'scopes',label:'lbl.role.resources.scopes'}
        ],
        options: [
            // { value: 'addEdit', text: i18n.t('lbl.role.resources.scope.addEdit'), label: 'lbl.role.resources.scope.addEdit' },
            { value: 'addEdit', text: '新增编辑' },
            { value: 'search', text: '查看' },
            { value: 'delete', text: '删除' }
        ]
    }).withActions({
        loadAllMenus(context) {
            context.dispatch("api/get", {
                url: process.env.VUE_APP_ADM_API_URL + "adm-service/adm/module/findAllMenus"
            }, { root: true })
            .then(function(data) {
                context.commit("setAllMenus", data);
            })
        }
    })
    .withMutations({
        convertStr2Arr(state,newResources) {
            state.entity.resources = newResources;
        },
        setAllMenus(state, allMenus) {
            state.allMenus = allMenus;
        },
        updateResources(state) {
            var arr = state.entity.resources;
            for(var i=0,len=arr.length; i<len; i++) {
                var fc = arr[i].functions;
                var sc = arr[i].scopes;
                if(typeof(fc)=='string' && fc!=='') {
                    var str1 = fc.slice(1,fc.length-1);
                    var tempArr1 = str1.split(",");
                    for(var k=0,l=tempArr1.length; k<l; k++) {
                        var s1 = tempArr1[k];
                        tempArr1[k] = s1.substring(1,s1.length-1);
                    }
                    arr[i].functions = tempArr1;
                }
                if(typeof(sc)=='string' && sc!=='') {
                    var str2 = sc.slice(1,sc.length-1);
                    var tempArr2 = str2.split(",");
                    for(var j=0,length=tempArr2.length; j<length; j++) {
                        var s2 = tempArr2[j];
                        tempArr2[j] = s2.substring(1,s2.length-1);
                    }
                    arr[i].scopes = tempArr2;
                }
            }
        },
        addResource(state,object) {
            state.entity.resources.push(object);
        },
        deleteResource(state,index) {
            state.entity.resources.splice(index,1);
        }
    })    
    .buildStore()
